import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaskChecklist = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "task-checklist" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M7.75,3.749h-4a1.5,1.5,0,0,0-1.5,1.5v16.5a1.5,1.5,0,0,0,1.5,1.5h16.5a1.5,1.5,0,0,0,1.5-1.5V5.249a1.5,1.5,0,0,0-1.5-1.5h-4"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.921,4.736a.751.751,0,0,1-.712.513H8.791a.751.751,0,0,1-.712-.513l-1-3A.749.749,0,0,1,7.791.749h8.418a.749.749,0,0,1,.712.987Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M18.75,6.749v9.878a1.5,1.5,0,0,1-.439,1.061l-2.122,2.121a1.5,1.5,0,0,1-1.06.44H6a.75.75,0,0,1-.75-.75V6.749"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M14.25,20.249v-3a1.5,1.5,0,0,1,1.5-1.5h3"
		})
	]
});
export default SvgTaskChecklist;
